module.exports = __webpack_public_path__ + "img/5.59f13c93.jpg";